var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.params.id === undefined)?_c('entity-list',{attrs:{"form-config":_vm.formConfig}}):(_vm.$route.params.id !== undefined)?_c('entity-edit',{attrs:{"entity-id":_vm.$route.params.id,"form-config":_vm.formConfig}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }